import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { MobileBottomNav } from '../MobileBottomNav';
import { ScrollToTop } from 'shared/utils/ScrollToTop';

export function Layout() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-surface flex flex-col pb-24 md:pb-0">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[200] focus:bg-tertiary focus:text-on-tertiary focus:px-4 focus:py-2 focus:rounded-full focus:font-sans focus:text-sm focus:outline-none"
      >
        {t('a11y.skipToContent')}
      </a>
      <ScrollToTop />
      <Header />
      <main id="main-content" className="flex-1 pt-24">
        <Outlet />
      </main>
      <Footer />
      <MobileBottomNav />
    </div>
  );
}
